import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const BarChart = ({
  typeGender,
  dataArray,
  numGrade4,
  numGrade5,
  numGrade6,
}) => {
  const data = {
    datasets: [
      {
        backgroundColor: ["#FFBF86", "#FFF47D", "#C2F784"],
        data: [dataArray.grade4, dataArray.grade5, dataArray.grade6],
        label: "คะแนน",
      },
    ],
    labels: typeGender
      ? [
          `นักเรียนชาย(${numGrade4})`,
          `นักเรียนหญิง(${numGrade5})`,
          `ทั้งหมด(${numGrade6})`,
        ]
      : [
          `ป.4 (${numGrade4} คน)`,
          `ป.5 (${numGrade5} คน)`,
          `ป.6 (${numGrade6} คน)`,
        ],
  };
  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "y",
    scales: {
      xAxes: [
        {
          barThickness: 5,
          maxBarThickness: 5,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            // fontColor: theme.palette.text.secondary,
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            // fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0,
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            // color: theme.palette.divider,
            // zeroLineColor: theme.palette.divider,
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: typeGender
          ? "คะแนนเฉลี่ยของนักเรียนแต่ละเพศ(เต็ม 100)"
          : "คะแนนเฉลี่ยของแต่ละชั้นปี(เต็ม 100)",
      },
    },
    tooltips: {
      intersect: false,
      borderWidth: 1,
      enabled: true,
      mode: "index",

      //   backgroundColor: theme.palette.background.default,
      //   bodyFontColor: theme.palette.text.secondary,
      //   borderColor: theme.palette.divider,
      //   footerFontColor: theme.palette.text.secondary,
      //   titleFontColor: theme.palette.text.primary,
    },
  };
  return <Bar data={data} options={options} />;
};

export default BarChart;
